import React from 'react'
import MaterialSymbol from '../material-symbol'

const Visibility = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="visibility" {...props} />
))

Visibility.displayName = 'Visibility'

export default Visibility
